module.exports = __webpack_public_path__ + "static/media/Chat word.600f8c1f.svg";